import React from 'react';
import { Box } from '@mui/material';
import AutocompleteCqlFecha from '../performance-components/buttons_cqlFecha.js';
import AutocompleteLayersGeoserver from '../performance-components/buttons_layersAI.js';
import AutocompleteIssueTimestamp from '../performance-components/buttons-issueTime.js';
import AutocompleteIssueTimestampHours from '../performance-components/buttons-issueTime_hours.js';
import AutocompleteIssueTimestampCrossBorder from './buttons-issueTime-cross.js';
import AutocompleteIssueTimestampHoursCrossBorder from './buttons-issueTime_hours-cross.js';

/**
 * Container component for analytics view control buttons
 * @param {Object} props - Component props
 * @returns {JSX.Element} AnalyticsButtonsContainer component
 */
const AnalyticsButtonsContainer = ({
  cqlFecha,
  selectedModel,
  cqlFechaMax,
  cqlFechaMin,
  issueTimeOptions,
  issueTime,
  crossIssueTime,
  onDateChange,
  onModelClick,
  onDateSelect,
  onTimeSelect,
  onCrossDateSelect,
  onCrossTimeSelect,
  onBackdropOpen,
  onBackdropClose,
  setIssueTimeOptions,
  showCrossBorderControls = true,
  layout = 'full' // 'full' or 'simple'
}) => {
  if (layout === 'simple') {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'center' }}>
        <Box sx={{ marginX: 2 }}>
          <AutocompleteCqlFecha cqlFecha={cqlFecha} handleDateChange={onDateChange} />
        </Box>
        <Box sx={{ marginX: 2 }}>
          <AutocompleteLayersGeoserver selectedModel={selectedModel} handleModelClick={onModelClick} />
        </Box>
      </Box>
    );
  }

  return (
    <div className="buttons-container">
      <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', mb: 2 }}>
        {/* Left group: 3 buttons */}
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Box sx={{ mb: 0, mx: 0.5 }}>
            <AutocompleteLayersGeoserver 
              selectedModel={selectedModel} 
              handleModelClick={onModelClick} 
            />
          </Box>
          <Box sx={{ mb: 0, mx: 0.5 }}>
            <AutocompleteIssueTimestamp
              handleDateSelect={onDateSelect}
              cqlFechaMax={cqlFechaMax}
              cqlFechaMin={cqlFechaMin}
              handleBackdropOpen={onBackdropOpen}
              handleBackdropClose={onBackdropClose}
              setIssueTimeOptions={setIssueTimeOptions}
            />
          </Box>
          <Box sx={{ mb: 0, mx: 0.5 }}>
            <AutocompleteIssueTimestampHours
              issueTimeOptions={issueTimeOptions}
              issueTime={issueTime}
              handleTimeSelect={onTimeSelect}
            />
          </Box>
        </Box>

        {/* Center group: calendar */}
        <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center', mb: 0, mt: 1 }}>
          <AutocompleteCqlFecha cqlFecha={cqlFecha} handleDateChange={onDateChange} />
        </Box>

        {/* Right group: CrossBorder buttons */}
        {showCrossBorderControls && (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ mb: 0, mx: 0.5 }}>
              <AutocompleteIssueTimestampCrossBorder
                handleDateSelect={onCrossDateSelect}
                cqlFechaMax={cqlFechaMax}
                cqlFechaMin={cqlFechaMin}
                handleBackdropOpen={onBackdropOpen}
                handleBackdropClose={onBackdropClose}
                setIssueTimeOptions={setIssueTimeOptions}
              />
            </Box>
            <Box sx={{ mb: 0, mx: 0.5 }}>
              <AutocompleteIssueTimestampHoursCrossBorder
                issueTimeOptions={issueTimeOptions}
                issueTime={crossIssueTime}
                handleTimeSelect={onCrossTimeSelect}
              />
            </Box>
          </Box>
        )}
      </Box>
    </div>
  );
};

export default AnalyticsButtonsContainer;
